/* Homepage media stays in view while copy and following sections scroll normally. */
(() => {
  if (!document.body.classList.contains('template-index') && !document.querySelector('[data-c24-scroll-hero]')) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let hero, frame = 0;
  function update() {
    frame = 0;
    if (!hero?.isConnected) return;
    const rect = hero.getBoundingClientRect();
    const offset = reduced.matches ? 0 : Math.max(0, Math.min(-rect.top, rect.height));
    hero.style.setProperty('--c24-hero-scroll', `${offset}px`);
  }
  function queue() { if (!frame) frame = requestAnimationFrame(update); }
  function init() {
    hero = document.querySelector('[data-c24-scroll-hero]') || document.querySelector('.video-parent-section');
    if (!hero) return;
    hero.classList.add('c24-scroll-hero');
    // Keep the existing play/pause control attached to the section, not the pinned media.
    const button = hero.querySelector('[data-c24-video-toggle]');
    if (button && button.parentElement !== hero) hero.append(button);
    queue();
  }
  addEventListener('scroll', queue, {passive:true});
  addEventListener('resize', queue, {passive:true});
  addEventListener('pageshow', queue);
  reduced.addEventListener('change', queue);
  document.addEventListener('shopify:section:load', init);
  init();
})();
